import { render, staticRenderFns } from "./EdenTableColumnHeader.vue?vue&type=template&id=d2ed1790&scoped=true"
import script from "./EdenTableColumnHeader.vue?vue&type=script&lang=js"
export * from "./EdenTableColumnHeader.vue?vue&type=script&lang=js"
import style0 from "./EdenTableColumnHeader.vue?vue&type=style&index=0&id=d2ed1790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ed1790",
  null
  
)

export default component.exports